<template>
  <div class="avatar-wrapper">
    <div class="avatar-preivew">
      <el-button
        v-if="hasThumbnail"
        type="info"
        size="medium"
        circle
        @click="removePhoto"
      >
        <i class="el-icon-close"></i>
      </el-button>
    </div>
    <el-upload
      class="avatar-uploader"
      drag
      action="#"
      :auto-upload="false"
      :show-file-list="false"
      :on-change="setPhoto"
      :on-preview="handleAvatarPreview"
      :on-remove="handleAvatarRemove"
      :before-upload="beforeAvatarUpload"
    >
      <img
        v-if="hasThumbnail"
        :src="thumbnailUrl"
        class="avatar-thumbnail-preview"
      />
      <template v-else>
        <i class="el-icon-plus" style="font-size: 3rem"></i>
        <div class="el-upload__text">拖曳圖片至此</div>
      </template>
      <div class="el-upload__tip" slot="tip">
        IMAGE/JPEG - 圖片檔案 - 需小於 300 kb
      </div>
    </el-upload>
  </div>
</template>

<script>
export default {
  props: {
    photo: Object,
    photoUrl: String,
  },
  data() {
    return { localPhotoUrl: null }
  },
  computed: {
    thumbnailUrl() {
      return this.localPhotoUrl || this.photoUrl
    },
    hasThumbnail() {
      return this.thumbnailUrl ? true : false
    },
  },
  methods: {
    _previewImage(_file) {
      if (!_file) return
      const file = _file.raw

      const reader = new FileReader()
      reader.onload = (e) => {
        this.localPhotoUrl = e.target.result
      }

      reader.readAsDataURL(file) // convert to base64 strin
    },
    setPhoto(file, fileList) {
      const error = this.$message ? this.$message.error : console.error

      if (!file || !file.raw) return

      const isValidFormat =
        ['image/jpeg', 'image/jpg'].indexOf(file.raw.type) !== -1
      const isSmallThen300k = file.size / 1024 < 300

      if (!isValidFormat) {
        error('圖片格式需為 JPEG / JPG')
      }
      if (!isSmallThen300k) {
        error('圖片大小請小於 300kb')
      }

      if (isValidFormat && isSmallThen300k) {
        this._previewImage(file)
        this.$emit('photo-updated', file)
      }
    },
    removePhoto() {
      this.localPhotoUrl = null
      this.$emit('photo-updated', null)
    },
    handleAvatarPreview(file) {
      log('preview file: ', file)
    },
    handleAvatarRemove(file) {
      log('remove file: ', file)
    },
    beforeAvatarUpload(file) {
      log('before file upload: ', file)
    },
  },
}
</script>

<style scoped>
input[type='file'].el-upload__input {
  display: none;
}
.el-upload-dragger {
  width: 200px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.avatar-wrapper {
  margin-top: 30px;
}
.avatar-preivew {
  position: relative;
}
.avatar-preivew button {
  display: block;
  position: absolute;
  z-index: 2;
  bottom: -15px;
  left: 175px;
}
.avatar-thumbnail-preview {
  object-fit: contain;
}
.el-upload__tip {
  margin-top: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/longTermCare/AvatarUploader.vue